import { React, useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

import { Alerta } from '../../components/alerta';
import { fetchFlask } from '../../utils/fetchFlask';
import { maskCpfCnpj } from '../../utils/maskCpfCnpj';
import SubmitButton from '../../components/submitButton';

const QuitacaoDebitos = () => {
    const [cpfCnpj, setCpfCnpj] = useState('');
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState('');
    const [openAlerta, setOpenAlerta] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);

    async function submitQuitacaoDebitos (e) {
        e.preventDefault();
        setIsSubmit(true);

        const body = JSON.stringify({
            cpfCnpj
        });

        const response = await fetchFlask('quitacaoDebitos', body);
        setStatus(response.status);
        setOpenAlerta(true);
        if (response.status !== 'error') {
            const pdfBlob = new Blob([response], { type: 'application/pdf' });
            const pdfObjectURL = URL.createObjectURL(pdfBlob);
            window.open(pdfObjectURL, '_blank');
            setCpfCnpj('');
            setMessage('Arquivo gerado com sucesso!');
        } else {
            setMessage(response.message);
        }
        setIsSubmit(false);
    };

    return (
        <Box className='mainBox'>
            <Alerta
                texto={message}
                status={status}
                open={openAlerta}
                handleClose={() => setOpenAlerta(false)}
            />
            <Typography variant='h3'>
                Declaração de Quitação de Débitos
            </Typography>

            <form action='' method='POST' id='formCadastrarCC' onSubmit={submitQuitacaoDebitos}>
                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <TextField
                        required
                        label='CPF/CNPJ'
                        value={cpfCnpj}
                        onChange={(e) => setCpfCnpj(maskCpfCnpj(e.target.value))}
                    />
                </FormControl>

                <FormControl sx={{ display: 'block', marginTop: '20px' }}>
                    <SubmitButton isSubmit={isSubmit}>Gerar Declaração</SubmitButton>
                </FormControl>
            </form>
        </Box>
    );
};

export default QuitacaoDebitos;
